import { PaginationState } from 'app/shared/pagination/pagination.model';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  changeCaseAttachmentActivity,
  deleteCaseAttachment,
  fetchCaseAttachment,
  fetchCaseAttachments,
  getCaseAttachmentFileRules,
  saveCaseAttachment,
} from 'app/edozvola/cases/case-attachment/service/case-attachment.service';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { CaseAttachmentFormModel } from 'app/edozvola/cases/case-attachment/model/case-attachment.model';
import { toast } from 'react-toastify';
import success = toast.success;
import error = toast.error;
import { messages, TABLE_QUERY_KEYS } from 'app/config/constants';
import { useLocation } from 'react-router-dom';

export const fetchCaseAttachmentsQuery = (pagination: PaginationState, uuid: string) => {
  const location = useLocation();
  const caseInPreview = location.pathname.includes('cases-preview');
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.CASE_ATTACHMENTS_TABLE, { ...pagination }, uuid, { caseInPreview: caseInPreview }],
    queryFn: ({ signal }) => fetchCaseAttachments({ signal, pagination, uuid, caseInPreview }),
  });
};

export const fetchCaseAttachmentQuery = (uuid: string, idCaseAttachment: string) => {
  return useQuery({
    queryKey: ['case-attachment', uuid, idCaseAttachment],
    queryFn: () => fetchCaseAttachment({ uuid, idCaseAttachment }),
    enabled: !!idCaseAttachment,
  });
};

export const updateCaseAttachmentQuery = (uuid: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: CaseAttachmentFormModel) => saveCaseAttachment(uuid, data),
    onSuccess: (data: CaseAttachmentFormModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_ATTACHMENTS_TABLE] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const changeActivityQuery = () => {
  return useMutation({
    mutationFn: (idCaseAttachment: number) => changeCaseAttachmentActivity(idCaseAttachment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_ATTACHMENTS_TABLE] });
    },
  });
};

export const deleteCaseAttachmentQuery = (closeModalCallback: Function) => {
  return useMutation({
    mutationFn: (idCaseAttachment: number) => deleteCaseAttachment(idCaseAttachment),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_ATTACHMENTS_TABLE] });
      closeModalCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const getCaseAttachmentFileRulesMutation = setFileRules => {
  return useMutation({
    mutationFn: (idRequestAttachment: number) => getCaseAttachmentFileRules(idRequestAttachment),
    onSuccess: data => setFileRules(data),
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
